import {
  Box,
  Center,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Image,
  Input,
  InputGroup,
  InputLeftAddon,
  Radio,
  RadioGroup,
  Spacer,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import FormInput from "../../../components/input/";
import { color } from "../../../utils/theme";
import { Divider } from "@chakra-ui/react";
import { useFormik } from "formik";
import FormButton from "../../../components/button/";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "@chakra-ui/react";
import { signupFormik } from "../../../utils/formik/signup";
import { Option } from "../../../utils/types/props.dropdown";
import Select from "react-select";
import { signupUser } from "./signupService";
import { RootState } from "../../../redux/reducer/rootReducer";
import { getFacilities } from "../../../redux/action";
import { AppDispatch } from "../../../redux/store";
import {
  getFacility,
  getRegion,
  getWoreda,
  getZone,
  Region,
  Woreda,
  Zone,
} from "./mfrService";
import { Facility } from "../../../redux/reducer/facilityReducer";

const SignUp = () => {
  const [submitting, setSubmitting] = useState(false);
  const [sex] = useState<Option[]>([
    {
      label: "Male",
      value: "Male",
    },
    {
      label: "Female",
      value: "Female",
    },
  ]);

  const [position] = useState<Option[]>([
    {
      label: "Position 1",
      value: "position1",
    },
    {
      label: "Position 2",
      value: "position2",
    },
    {
      label: "Position 3",
      value: "position3",
    },
  ]);

  const rawFacilities = useSelector(
    (state: RootState) => state.facilities.data
  );
  const [facilities, setFacilities] = useState<Option[]>([]);

  const [showError, setShowError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [password, setPassword] = useState("");
  const [isAdmin, setIsAdmin] = useState(true);
  const [fileName, setFileName] = useState("");
  const [uploadDocumentError, setUploadDocumentError] = useState(false);
  const [regionOptions, setRegionOptions] = useState<Option[]>([]);
  const [zoneOptions, setZoneOptions] = useState<Option[]>([]);
  const [woredaOptions, setWoredaOptions] = useState<Option[]>([]);
  const [facilityOptions, setFacilityOptions] = useState<Option[]>([]);
  const [selectedRegion, setSelectedRegion] = useState<string>("");
  const [selectedZone, setSelectedZone] = useState<string>("");
  const [selectedWoreda, setSelectedWoreda] = useState<string>("");
  const [selectedPosition, setSelectedPosition] = useState<string>("");
  const [positionErrorMessage, setPositionErrorMessage] = useState<string>("");
  const [file, setFile] = useState<File | null>(null);
  const [isSponsored, setIsSponsored] = useState(true);

  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    dispatch(getFacilities());
  }, [dispatch]);

  useEffect(() => {
    let regions: Region[] = [];

    getRegion().then((result) => {
      if (result) {
        regions = result as Region[];
        let options = regions.map((region) => {
          return {
            label: region.name,
            value: region.id.toString(),
          };
        });

        setRegionOptions(options);
      }
    });
  }, []);

  useEffect(() => {
    let zones: Zone[] = [];

    getZone(selectedRegion).then((result) => {
      if (result) {
        zones = result as Zone[];
        let options = zones.map((region) => {
          return {
            label: region.name,
            value: region.id.toString(),
          };
        });

        setZoneOptions(options);
      }
    });
  }, [selectedRegion]);

  useEffect(() => {
    let woredas: Woreda[] = [];

    getWoreda(selectedZone).then((result) => {
      if (result) {
        woredas = result as Woreda[];
        let options = woredas.map((woreda) => {
          return {
            label: woreda.name,
            value: woreda.id.toString(),
          };
        });

        setWoredaOptions(options);
      }
    });
  }, [selectedZone]);

  useEffect(() => {
    let facilities: Facility[] = [];

    getFacility(selectedWoreda).then((result) => {
      if (result) {
        facilities = result as Facility[];
        let options = facilities.map((facility) => {
          return {
            label: facility.name,
            value: facility.id.toString(),
          };
        });

        setFacilityOptions(options);
      }
    });
  }, [selectedWoreda]);

  useEffect(() => {
    if (rawFacilities) {
      const dep = rawFacilities.map((facility) => ({
        label: facility.name,
        value: facility.id as any,
      }));
      setFacilities(dep);
    }
  }, [rawFacilities]);

  const toast = useToast();
  const formik = useFormik({
    ...signupFormik,
    onSubmit: async () => {
      if (isSponsored && selectedPosition === "") {
        setPositionErrorMessage("Position is required");
        return;
      }
      if (isAdmin && fileName === "" && isSponsored) {
        setUploadDocumentError(true);
        return;
      } else {
        setSubmitting(true);
        if (!isSponsored) {
          formik.setFieldValue("facility", "0");
        }

        const signup = await signupUser(formik.values, file, isSponsored);
        if (signup.success) {
          setShowError(false);
          setSubmitting(false);
          navigate("/login");

          toast({
            title: "Account Created.",
            position: "top-right",
            description: "Account has been created successfully",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          formik.resetForm();
          navigate("/login");
        } else {
          const error = signup.data;
          const { title, description } = displayErrorMessages(error.code);
          setSubmitting(false);
          toast({
            title: title,
            position: "top-right",
            description: description,
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      }
    },
  });
  const displayErrorMessages = (error: any) => {
    let title = "";
    let description = "";
    if (error === "USER_ALREADY_REGISTERED") {
      title = "User already registered";
      description =
        "User already registered, please login or change the email address.";
    } else if (error === "ALREADY_HAS_FACILITY_ADMIN") {
      title = "Facility Admin already registered";
      description =
        "This facility already has a facility admin, please choose another facility.";
    } else {
      title = "Account Creation fails.";
      description = "Please try again!";
    }
    console.log("error: ", error);
    return {
      title: title,
      description: description,
    };
  };

  const handleAdminToggle = (sponsored: boolean) => {
    formik.setFieldValue("isAdmin", sponsored);
    if (!sponsored) {
      formik.setFieldValue("adminDocument", "");
      setFileName("");
      setUploadDocumentError(false);
    } else {
      formik.setFieldValue("adminDocument", fileName);
      setFileName(fileName);
    }
  };

  return (
    <Box minH={"100vh"}>
      <Center h={"100%"} textAlign={"left"} fontWeight={"normal"}>
        <Box
          bg={color.secondary}
          w={"90%"}
          my={20}
          display={"flex"}
          justifyContent={"center"}
          alignContent={"center"}
          alignItems={"center"}
        >
          <Stack
            rounded={"sm"}
            boxShadow={"sm"}
            borderWidth={0.5}
            gap={6}
            borderColor={color.teritary}
            padding={10}
            w={["100%", "75%", "50%", "75%", "75%", "50%"]}
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"flex-start"}
          >
            <Box
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
              alignContent={"center"}
              alignItems={"center"}
              height={"100%"}
            >
              <Image
                width="10%"
                height="auto"
                src={require("../../../assets/logo.png")}
              />
              <Text color={color.text} fontSize={22} variant={"Header"}>
                Create an account
              </Text>
            </Box>
            <Divider />
            <Box mt={4}>
              <Flex direction={"row"} gap={4}>
                <FormInput
                  name="firstname"
                  isRequired={true}
                  value={formik.values.firstname}
                  label="First Name"
                  type="text"
                  id="First Name"
                  errorMessage={formik.errors.firstname as string}
                  onChange={(event) => {
                    formik.setFieldValue("firstname", event.target.value);
                  }}
                />

                <FormInput
                  id="middlename"
                  isRequired={true}
                  value={formik.values.middlename}
                  name="middlename"
                  label="Middle Name"
                  type={"text"}
                  errorMessage={formik.errors.middlename as string}
                  onChange={(event) => {
                    formik.setFieldValue("middlename", event.target.value);
                  }}
                />
                <FormInput
                  id="lastname"
                  isRequired={true}
                  value={formik.values.lastname}
                  name="lastname"
                  label="Last Name"
                  type={"text"}
                  errorMessage={formik.errors.lastname as string}
                  onChange={(event) => {
                    formik.setFieldValue("lastname", event.target.value);
                  }}
                />
              </Flex>
              <Spacer h={"20px"} />
              <FormControl
                style={{ width: "100%" }}
                display={"flex"}
                flexDirection={"row"}
              >
                <FormLabel
                  display={"flex"}
                  mb={0}
                  fontSize={18}
                  fontWeight={"500"}
                  color={color.text}
                >
                  Sex
                  <Text color={"red"} mx={1} fontSize={24}>
                    *
                  </Text>
                </FormLabel>

                <RadioGroup
                  onChange={(value) => {
                    formik.setFieldValue("sex", value);
                  }}
                  value={formik.values.sex}
                >
                  <Flex direction={"column"}>
                    {sex.map((option) => (
                      <Radio key={option.value} value={option.value}>
                        {option.label}
                      </Radio>
                    ))}
                  </Flex>
                </RadioGroup>
                <Text
                  marginY={3}
                  fontWeight={"normal"}
                  color={"red"}
                  fontSize={13}
                >
                  {formik.errors.sex as string}
                </Text>
              </FormControl>
              <Spacer h={"20px"} />
              <HStack>
                <FormControl>
                  <FormLabel
                    display={"flex"}
                    mb={0}
                    fontSize={18}
                    fontWeight={"500"}
                    color={color.text}
                  >
                    Phone Number
                    <Text color={"red"} mx={1} fontSize={24}>
                      *
                    </Text>
                  </FormLabel>
                  <InputGroup>
                    <InputLeftAddon>+251</InputLeftAddon>
                    <Input
                      type="number"
                      fontFamily={"body"}
                      onChange={(event) =>
                        formik.setFieldValue("phonenumber", event.target.value)
                      }
                      inputMode="numeric"
                      placeholder="phone number"
                    />
                  </InputGroup>
                  <Text
                    marginY={3}
                    fontWeight={"normal"}
                    color={"red"}
                    fontSize={13}
                  >
                    {formik.errors.phonenumber as string}
                  </Text>
                </FormControl>
                <FormControl>
                  <FormInput
                    id="email"
                    isRequired={true}
                    value={formik.values.email}
                    name="email"
                    label="Email"
                    type={"email"}
                    errorMessage={formik.errors.email as string}
                    onChange={(event) => {
                      formik.setFieldValue("email", event.target.value);
                    }}
                  />
                </FormControl>
              </HStack>
              <Spacer h={"20px"} />
              <Tabs
                variant="unstyled"
                onChange={(index) => {
                  let sponsored = index === 0 ? true : false;
                  handleAdminToggle(sponsored);
                  setIsSponsored(sponsored);
                }}
              >
                <TabList
                  display={"flex"}
                  flexDirection={"row"}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  alignContent={"center"}
                >
                  <Text mx={1} fontSize={17}>
                    User Type
                  </Text>

                  <HStack
                    w={"70%"}
                    sx={{ borderWidth: 1, borderColor: color.primary }}
                  >
                    <Tab
                      w={"50%"}
                      _selected={{ color: "white", bg: "blue.500" }}
                    >
                      Facility Admin
                    </Tab>
                    <Tab
                      w={"50%"}
                      _selected={{ color: "white", bg: "blue.400" }}
                    >
                      Non Sponsored
                    </Tab>
                  </HStack>
                </TabList>
                <Spacer h={"20px"} />
                <TabPanels>
                  <TabPanel>
                    <Flex
                      id="adminFields"
                      direction={"column"}
                      gap={5}
                      borderWidth={1}
                      borderColor={"gray.200"}
                      padding={5}
                      w={"100%"}
                    >
                      <HStack>
                        <FormControl style={{ width: "100%" }}>
                          <FormLabel
                            display={"flex"}
                            mb={0}
                            fontSize={18}
                            fontWeight={"500"}
                            color={color.text}
                          >
                            Region
                            <Text color={"red"} mx={1} fontSize={24}>
                              *
                            </Text>
                          </FormLabel>

                          <Select
                            placeholder=" "
                            options={regionOptions}
                            onChange={(event) => {
                              setSelectedRegion(event?.value ?? "");
                            }}
                          />
                          <Text
                            marginY={3}
                            fontWeight={"normal"}
                            color={"red"}
                            fontSize={13}
                          >
                            {formik.errors.facility as string}
                          </Text>
                        </FormControl>
                        <FormControl style={{ width: "100%" }}>
                          <FormLabel
                            display={"flex"}
                            mb={0}
                            fontSize={18}
                            fontWeight={"500"}
                            color={color.text}
                          >
                            Zone
                            <Text color={"red"} mx={1} fontSize={24}>
                              *
                            </Text>
                          </FormLabel>

                          <Select
                            placeholder=" "
                            options={zoneOptions}
                            onChange={(event) => {
                              setSelectedZone(event?.value ?? "");
                            }}
                          />
                          <Text
                            marginY={3}
                            fontWeight={"normal"}
                            color={"red"}
                            fontSize={13}
                          >
                            {formik.errors.facility as string}
                          </Text>
                        </FormControl>
                      </HStack>
                      <HStack>
                        <FormControl style={{ width: "100%" }}>
                          <FormLabel
                            display={"flex"}
                            mb={0}
                            fontSize={18}
                            fontWeight={"500"}
                            color={color.text}
                          >
                            Woreda
                            <Text color={"red"} mx={1} fontSize={24}>
                              *
                            </Text>
                          </FormLabel>

                          <Select
                            placeholder=" "
                            options={woredaOptions}
                            onChange={(event) => {
                              setSelectedWoreda(event?.value ?? "");
                            }}
                          />
                          <Text
                            marginY={3}
                            fontWeight={"normal"}
                            color={"red"}
                            fontSize={13}
                          >
                            {formik.errors.facility as string}
                          </Text>
                        </FormControl>
                        <FormControl style={{ width: "100%" }}>
                          <FormLabel
                            display={"flex"}
                            mb={0}
                            fontSize={18}
                            fontWeight={"500"}
                            color={color.text}
                          >
                            Facility
                            <Text color={"red"} mx={1} fontSize={24}>
                              *
                            </Text>
                          </FormLabel>

                          <Select
                            placeholder=" "
                            options={facilityOptions}
                            onChange={(event) => {
                              formik.setFieldValue("facility", event?.value);
                            }}
                          />
                          <Text
                            marginY={3}
                            fontWeight={"normal"}
                            color={"red"}
                            fontSize={13}
                          >
                            {formik.errors.facility as string}
                          </Text>
                        </FormControl>
                      </HStack>
                      <FormControl style={{ width: "100%" }}>
                        <FormLabel
                          display={"flex"}
                          mb={0}
                          fontSize={18}
                          fontWeight={"500"}
                          color={color.text}
                        >
                          Position
                          <Text color={"red"} mx={1} fontSize={24}>
                            *
                          </Text>
                        </FormLabel>

                        <Select
                          placeholder=" "
                          options={position}
                          onChange={(event) => {
                            setSelectedPosition(event?.value || "");
                            formik.setFieldValue("position", event?.value);
                          }}
                        />
                        <Text
                          marginY={3}
                          fontWeight={"normal"}
                          color={"red"}
                          fontSize={13}
                        >
                          {positionErrorMessage}
                        </Text>
                      </FormControl>
                      {/* <FormInput
                        id="position"
                        isRequired={true}
                        value={formik.values.position}
                        name="position"
                        label="Position"
                        type={"text"}
                        errorMessage={formik.errors.position as string}
                        onChange={(event) => {
                          setSelectedPosition(event.target.value);
                          formik.setFieldValue("position", event.target.value);
                        }}
                      /> */}
                      <FormControl marginTop={4}>
                        <FormLabel htmlFor="adminDocument" display="flex">
                          Upload approval letter (PDF only)
                          <Text color="red" mx={1} fontSize={24}>
                            *
                          </Text>
                        </FormLabel>
                        <Box
                          border="1px solid"
                          borderColor="gray.300"
                          borderRadius="md"
                          padding={2}
                          _hover={{ borderColor: "gray.500" }}
                        >
                          <Input
                            id="adminDocument"
                            name="adminDocument"
                            type="file"
                            accept="application/pdf"
                            onChange={(event) => {
                              const file = event?.target.files?.[0]?.name || "";
                              setFile(event?.target.files?.[0] || null);
                              setFileName(file);
                            }}
                            style={{ display: "none" }}
                          />
                          <Box
                            as="label"
                            htmlFor="adminDocument"
                            cursor="pointer"
                            display="block"
                            textAlign="center"
                            padding={2}
                            backgroundColor="gray.100"
                            borderRadius="md"
                            _hover={{ backgroundColor: "gray.200" }}
                          >
                            Choose Document
                          </Box>
                          {uploadDocumentError && (
                            <Text mt={2} fontSize="sm" color={"red"}>
                              Document upload is required!
                            </Text>
                          )}
                          {fileName && (
                            <Text mt={2} fontSize="sm" color={"green"}>
                              {fileName}
                            </Text>
                          )}
                        </Box>
                      </FormControl>
                    </Flex>
                  </TabPanel>
                  <TabPanel>
                    <Text></Text>
                  </TabPanel>
                </TabPanels>
              </Tabs>
              <Spacer h={"20px"} />
              <Flex direction={"row"} gap={5}>
                <FormInput
                  id="password"
                  isRequired={true}
                  value={formik.values.password}
                  name="password"
                  label="Create Password"
                  type={showPassword ? "text" : "password"}
                  errorMessage={formik.errors.password as string}
                  onChange={(event) => {
                    setPassword(event.target.value);
                    formik.setFieldValue("password", event.target.value);
                  }}
                />
                <FormInput
                  id="confirmpassword"
                  isRequired={true}
                  value={confirmPassword}
                  name="confirmpassword"
                  label="Confirm Password"
                  type={showPassword ? "text" : "password"}
                  onChange={(event) => {
                    //   formik.setFieldValue("position", event.target.value);
                    setConfirmPassword(event.target.value);
                  }}
                />
              </Flex>
              <Checkbox
                size="md"
                colorScheme="blue"
                mt={4}
                fontWeight={"500"}
                w={"100%"}
                onChange={(e) => setShowPassword(e.target.checked)}
              >
                Show Password
              </Checkbox>
              {showError && (
                <Text
                  marginY={3}
                  fontWeight={"normal"}
                  color={"red"}
                  fontSize={13}
                >
                  Passwords do not match
                </Text>
              )}
              <Spacer h={"20px"} />
              <Divider />
              <FormButton
                colorScheme={"blue"}
                onClick={() => {
                  if (password.toString() !== confirmPassword.toString()) {
                    setShowError(true);
                    return;
                  } else {
                    setShowError(false);
                  }
                  formik.handleSubmit();
                }}
                isLoading={submitting ? true : false}
              >
                Create Account
              </FormButton>
              <Text
                fontSize={15}
                textAlign={"center"}
                mt={2}
                fontWeight={"normal"}
              >
                Already have an account?{" "}
                <Link color="blue.500" href="login" fontWeight={"semibold"}>
                  Log in
                </Link>
              </Text>
            </Box>
          </Stack>
        </Box>
      </Center>
    </Box>
  );
};

export default SignUp;
